(() => {
  if (document.documentElement.dataset.productNfpaModalReady === 'true') return;

  const noticeSelector = '[data-product-nfpa-notice]';
  const triggerSelector = '[data-product-nfpa-modal-open]';
  const modalSelector = '[data-product-nfpa-modal]';
  const closeSelector = '[data-product-nfpa-modal-close]';

  const getTrigger = (modal) => modal.closest(noticeSelector)?.querySelector(triggerSelector);

  const closeModal = (modal, restoreFocus = true) => {
    const trigger = getTrigger(modal);

    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
      trigger?.setAttribute('aria-expanded', 'false');
    }

    if (restoreFocus) trigger?.focus();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);

    if (trigger) {
      const modal = trigger.closest(noticeSelector)?.querySelector(modalSelector);
      if (!modal) return;

      event.preventDefault();

      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }

      trigger.setAttribute('aria-expanded', 'true');
      return;
    }

    const closeButton = event.target.closest(closeSelector);
    if (closeButton) {
      const modal = closeButton.closest(modalSelector);
      if (modal) closeModal(modal);
      return;
    }

    const modal = event.target.closest(modalSelector);
    if (!modal || event.target !== modal) return;

    const modalBounds = modal.getBoundingClientRect();
    const clickedBackdrop =
      event.clientX < modalBounds.left ||
      event.clientX > modalBounds.right ||
      event.clientY < modalBounds.top ||
      event.clientY > modalBounds.bottom;

    if (clickedBackdrop) closeModal(modal);
  });

  document.addEventListener(
    'close',
    (event) => {
      if (!event.target.matches(modalSelector)) return;
      getTrigger(event.target)?.setAttribute('aria-expanded', 'false');
    },
    true
  );

  document.documentElement.dataset.productNfpaModalReady = 'true';
})();
